export default __webpack_public_path__ + "static/media/erx-prepare-icon.9c92d3eb.svg";